import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M10 10C8.5625 10 7.25 9.25 6.53125 8C5.8125 6.78125 5.8125 5.25 6.53125 4C7.25 2.78125 8.5625 2 10 2C11.4062 2 12.7188 2.78125 13.4375 4C14.1562 5.25 14.1562 6.78125 13.4375 8C12.7188 9.25 11.4063 10 10 10ZM8.5625 11.5H11.4063C14.5 11.5 17 14 17 17.0938C17 17.5938 16.5625 18 16.0625 18H3.90625C3.40625 18 3 17.5938 3 17.0938C3 14 5.46875 11.5 8.5625 11.5Z"
	})
});
const ForwardRef = forwardRef(SvgUserFilled);
export default ForwardRef;
